// three.js preview: one mesh per band, orbit by drag. Core meshes are y-up with Z up from the bed;
// group.rotation.set(-PI/2, 0, 0) is the one flip that maps that into three's y-up view.
import * as THREE from 'three';
const PHI_EDGE = 0.05;
export function createPreview(canvas) {
  const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true });
  renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(35, 4 / 3, 1, 1000);
  let camR = 90, camTheta = 0.7, camPhi = 1.05;
  const placeCamera = () => { camera.position.set(camR * Math.sin(camPhi) * Math.cos(camTheta), camR * Math.cos(camPhi), camR * Math.sin(camPhi) * Math.sin(camTheta)); camera.lookAt(0, 0, 0); };
  const key = new THREE.DirectionalLight(0xffffff, 1.4); key.position.set(-30, 40, 0); camera.add(key);
  scene.add(new THREE.HemisphereLight(0xffffff, 0x888888, 1.0), camera);
  const group = new THREE.Group(); group.rotation.set(-Math.PI / 2, 0, 0); scene.add(group);
  const render = () => renderer.render(scene, camera);
  function setBands(bands) {
    for (const c of [...group.children]) { group.remove(c); c.geometry.dispose(); c.material.dispose(); }
    const bb = new THREE.Box3();
    for (const b of bands) {
      const geo = new THREE.BufferGeometry();
      geo.setAttribute('position', new THREE.BufferAttribute(new Float32Array(b.mesh.vertProperties), b.mesh.numProp));
      geo.setIndex(new THREE.BufferAttribute(new Uint32Array(b.mesh.triVerts), 1));
      geo.computeVertexNormals(); geo.computeBoundingBox(); bb.union(geo.boundingBox);
      group.add(new THREE.Mesh(geo, new THREE.MeshStandardMaterial({ color: b.color, roughness: 0.45, metalness: 0.05, flatShading: true })));
    }
    const c = bb.getCenter(new THREE.Vector3()); group.position.set(-c.x, 0, c.y);   // centre in XY, keep the bed at y=0
    const size = bb.getSize(new THREE.Vector3());
    camR = Math.max(size.x, size.y, size.z, 10) * 2.2; placeCamera(); render();
  }
  function resize() { const w = canvas.clientWidth, h = canvas.clientHeight; if (!w || !h) return; renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix(); render(); }
  let dragging = false, lx = 0, ly = 0;
  canvas.addEventListener('pointerdown', e => { dragging = true; lx = e.clientX; ly = e.clientY; canvas.setPointerCapture(e.pointerId); });
  canvas.addEventListener('pointermove', e => { if (!dragging) return; camTheta -= (e.clientX - lx) * 0.008; camPhi = Math.min(Math.PI - PHI_EDGE, Math.max(PHI_EDGE, camPhi - (e.clientY - ly) * 0.006)); lx = e.clientX; ly = e.clientY; placeCamera(); render(); });
  canvas.addEventListener('pointerup', () => { dragging = false; });
  new ResizeObserver(resize).observe(canvas); resize();
  return { setBands, resize };
}
